export const APP_NAME = 'MemoSlate.com'
export const REDIRECT_URL_KEY = 'redirectUrl'
